<template>
  <div class="dialog-container">
    <el-row :gutter="18">
      <el-col :span="24">
        <h2>Tax Return Estimate</h2>
        <p>Use the printed W-2s from the last step to complete a tax return estimate for your client.
            Once the estimate is complete, click the "Next Step" button to continue the application.</p>
      </el-col>
    </el-row>
  </div>
</template>

<script>

export default {
  name: 'eb-tax-return-estimate',
};

</script>
